(function() {
  var el = document.querySelector(".sh-filters");
  if (!el) { return; }

  var collectionUrl = el.dataset.collectionUrl;
  var path = window.location.pathname;
  if (path.charAt(path.length - 1) === "/") {
    path = path.slice(0, path.length - 1);
  }

  var parts = path.split("/");
  var rawTag = parts.length >= 4 ? parts[3] : "";
  var tagStr = rawTag ? decodeURIComponent(rawTag) : "";
  var hasColon = tagStr.indexOf(":") > -1;
  var activeTags = (tagStr && hasColon) ? tagStr.split("+") : [];

  function buildUrl(tags) {
    if (tags.length > 0) {
      return collectionUrl + "/" + tags.join("+");
    }
    return collectionUrl;
  }

  var buttons = el.querySelectorAll("[data-tag]");
  for (var i = 0; i < buttons.length; i++) {
    (function(btn) {
      var tag = btn.dataset.tag;
      if (activeTags.indexOf(tag) > -1) {
        btn.classList.add("sh-filter-btn--active");
        btn.classList.add("sh-filter-swatch--active");
      }
      btn.onclick = function(e) {
        e.preventDefault();
        var found = activeTags.indexOf(tag) > -1;
        var newTags = [];
        for (var j = 0; j < activeTags.length; j++) {
          if (activeTags[j] !== tag) { newTags.push(activeTags[j]); }
        }
        if (!found) { newTags.push(tag); }
        window.location.href = buildUrl(newTags);
      };
    })(buttons[i]);
  }

  if (activeTags.length > 0) {
    var bar = el.querySelector(".sh-filters__active-bar");
    bar.style.display = "flex";
    for (var k = 0; k < activeTags.length; k++) {
      (function(tag) {
        var labelText = tag.split(":").slice(1).join(":");
        var clean = "";
        for (var m = 0; m < labelText.length; m++) {
          clean += labelText.charAt(m) === "-" ? " " : labelText.charAt(m);
        }
        clean = clean.charAt(0).toUpperCase() + clean.slice(1);
        var chip = document.createElement("a");
        chip.href = "#";
        chip.className = "sh-filter-chip";
        chip.textContent = clean + " x";
        chip.onclick = function(e) {
          e.preventDefault();
          var rem = [];
          for (var n = 0; n < activeTags.length; n++) {
            if (activeTags[n] !== tag) { rem.push(activeTags[n]); }
          }
          window.location.href = buildUrl(rem);
        };
        bar.appendChild(chip);
      })(activeTags[k]);
    }
    var clearAll = document.createElement("a");
    clearAll.href = collectionUrl;
    clearAll.className = "sh-filter-clear";
    clearAll.textContent = "Clear all";
    bar.appendChild(clearAll);
  }

  var focusGroup = (tagStr && !hasColon) ? tagStr.toLowerCase() : "";
  if (focusGroup) {
    var groups = el.querySelectorAll(".sh-filter-group");
    for (var p = 0; p < groups.length; p++) {
      var gl = groups[p].querySelector(".sh-filter-group__label");
      if (gl && gl.textContent.trim().toLowerCase() === focusGroup) {
        groups[p].classList.add("sh-filter-group--focused");
      } else {
        groups[p].classList.add("sh-filter-group--unfocused");
      }
    }
  }
})();